/**
 * Removes the country or country / language from the url
 *
 * @param url string
 * @param countryCode string
 * @param languageCode string
 *
 * @returns url without country or without country / lang if exists
 */
export function removeCountryAndLanguageFromUrl(url: string, countryCode: string, languageCode?: string): string {
    try {
        const urlObject = new URL(url);
        const regex = new RegExp(`^/(?:${countryCode}(?:/${languageCode})?|${countryCode}|${languageCode})`, 'i');
        const sanitizedPath = urlObject.pathname.replace(regex, '');
        urlObject.pathname = sanitizedPath.startsWith('/') ? sanitizedPath : `/${sanitizedPath}`;
        return urlObject.toString();
    } catch {
        // Relative URL
        const regex = new RegExp(`^/(?:${countryCode}(?:/${languageCode})?|${countryCode}|${languageCode})`, 'i');
        const sanitizedUrl = url.replace(regex, '');
        return sanitizedUrl.startsWith('/') ? sanitizedUrl : `/${sanitizedUrl}`;
    }
}
